import { ReactNode } from "react";
import styled, { css } from "styled-components";
import COLORS from "components/atoms/colors";
import { TextSm } from "components/atoms/text";
import { InputChange } from "types/Form";

interface Props {
  className?: string;
  labelText?: string;
  children?: ReactNode;
  name: string;
  value: string | number | string[];
  checked?: boolean;
  onChange?: (e: InputChange) => void;
}

const InputRadio = ({
  className,
  labelText,
  children,
  name,
  value,
  checked,
  onChange,
}: Props) => {
  return (
    <label
      className={`inline-flex items-center gap-2 cursor-pointer ${className}`}
    >
      <Input
        type="radio"
        name={name}
        value={value}
        defaultChecked={checked}
        onChange={onChange}
        active={checked}
      />
      {children || (
        <TextSm className={`${checked ? "text-black-100%" : "text-black-40%"}`}>
          {labelText}
        </TextSm>
      )}
    </label>
  );
};

const Input = styled.input<{ active?: boolean }>`
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: ${COLORS.black["20%"]};
  outline: 1px solid ${COLORS.black["20%"]};
  border: 5px solid #fff;
  flex: none;

  ${({ active }) =>
    active &&
    css`
      outline: 0;
      background-color: #fff;
      border: 6px solid ${COLORS.primary.active};
    `}
`;

export default InputRadio;
